import React from "react";
import Layout from "../../../layouts";
import EcoEfficiencyDashboardFilter from "./EcoEfficiencyDashboardFilter";
import { Box } from "@mui/material";
import { EcoEfficiencyDashboardProvider } from "../../../contexts/EcoEfficiencyDashboardContext";
import EcoEfficiencyDashboardContent from "./EcoEfficiencyDashboardContent";
import { EcoEfficiencyTabMenuV2 } from "../_components/EcoEfficiencyTabMenu";
type Props = {};

const EcoEfficiencyDashboard = (props: Props) => {
  return (
    <EcoEfficiencyDashboardProvider>
      <Layout>
        <Box height={"100%"} display={"flex"} flexDirection={"column"}>
          <EcoEfficiencyTabMenuV2 />

          <Box
            display={"flex"}
            flexDirection={"column"}
            flex={1}
            bgcolor={"var(--white)"}
          >
            <EcoEfficiencyDashboardFilter />

            <EcoEfficiencyDashboardContent />
          </Box>
        </Box>
      </Layout>
    </EcoEfficiencyDashboardProvider>
  );
};

export default EcoEfficiencyDashboard;
